import React, { useEffect, useRef } from "react";
import useInvitations from "../hooks/useInvitations";
import Box from "./Box";
import { format } from "date-fns";

export default function () {
  return (
    <Box
      title="vip chatroom"
      backgroundColor="lavender"
      borderColor="firebrick"
    >
      <Messages />
    </Box>
  );
}

const Messages = () => {
  const { invitations } = useInvitations();
  const messages = rawMessages.map((m) => ({
    ...m,
    createdOn: new Date(m.createdOn),
  }));

  const scrollRef = useRef();
  useEffect(() => {
    if (scrollRef.current) {
      const el = scrollRef.current;
      el.scrollTop = el.scrollHeight;
    }
  }, [messages]);

  return (
    <div
      ref={scrollRef}
      style={{
        background: "rgba(0,0,0,0.08)",
        padding: "0.5rem",
        height: "20rem",
        overflow: "scroll",
      }}
    >
      {messages
        .filter((m) => !!m.createdOn)
        .map((msg, i) => {
          const name = invitations.find(
            (inv) => inv.id === msg.invitationId
          ).name;
          const dateStr = format(msg.createdOn, "MM/dd K:mmaaa");
          return (
            <div key={i} style={{ margin: "0.5em 0" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  fontWeight: "bold",
                }}
              >
                <div>{name}</div>
                <div>{dateStr}</div>
              </div>
              <div>{msg.text}</div>
            </div>
          );
        })}
      {/* <div ref={scrollRef}>test</div> */}
    </div>
  );
};

const rawMessages = [
  {
    createdOn: "2020-12-01T03:59:51.861Z",
    text: "WELCOME TO DECEMBER",
    invitationId: "3S9FKWoiStvSA0Nc0PUN",
  },
  {
    invitationId: "3S9FKWoiStvSA0Nc0PUN",
    text: "i am so excited to see your images. remember to submit early to guarantee a spot. you can always update it later B)",
    createdOn: "2020-12-01T04:01:33.586Z",
  },
  {
    invitationId: "kBBCFSBIeqy0ETEWuZ9C",
    createdOn: "2020-12-01T15:26:37.400Z",
    text: "Please move my image to tile 65",
  },
  {
    invitationId: "3S9FKWoiStvSA0Nc0PUN",
    createdOn: "2020-12-01T15:28:46.286Z",
    text: "Sorry, Pop. It's too late for that. At least you get to be next to Travis!",
  },
  {
    text: "Beep boop, is this a robot?",
    invitationId: "rmY55nI3GmMpkuMmLQnD",
    createdOn: "2020-12-01T16:59:53.704Z",
  },
  {
    invitationId: "3S9FKWoiStvSA0Nc0PUN",
    createdOn: "2020-12-01T17:16:35.513Z",
    text: "you're a robot",
  },
  {
    invitationId: "rmY55nI3GmMpkuMmLQnD",
    createdOn: "2020-12-01T17:22:27.803Z",
    text: "Why does the square count start at zero?",
  },
  {
    createdOn: "2020-12-01T17:36:08.123Z",
    text: "cause that's how counting works in programming and I'm all about optimizing the frank experience",
    invitationId: "3S9FKWoiStvSA0Nc0PUN",
  },
  {
    text: "My submission is a visual example of 2019 vs 2020. Jk, it’s my 2005 vs 2018 passport. But it ain’t far off",
    invitationId: "ZS7DO6lsSCQIqeoJ2Ug3",
    createdOn: "2020-12-01T18:01:00.248Z",
  },
  {
    invitationId: "ZS7DO6lsSCQIqeoJ2Ug3",
    text: "Better image to come, but until I pick, enjoy square #4",
    createdOn: "2020-12-01T18:02:02.782Z",
  },
  {
    createdOn: "2020-12-01T18:17:23.495Z",
    invitationId: "3S9FKWoiStvSA0Nc0PUN",
    text: "GREAT JOB!!! ",
  },
  {
    text: '<span class="spinThisShit">Snow!</span>',
    createdOn: "2020-12-01T20:05:40.508Z",
    invitationId: "kMEQQWDXay74SMc35HDu",
  },
  {
    text: "darn. was hoping that would work. Site looks fantastic! You really outdid yourself this year",
    invitationId: "kMEQQWDXay74SMc35HDu",
    createdOn: "2020-12-01T20:06:19.963Z",
  },
  {
    text: "I underdid this year. Like nice try on the injection ",
    invitationId: "3S9FKWoiStvSA0Nc0PUN",
    createdOn: "2020-12-01T20:11:37.058Z",
  },
  {
    invitationId: "qQTX9WFnUFp4ZTNoXd4t",
    createdOn: "2020-12-01T21:21:38.225Z",
    text: "this is fun",
  },
  {
    text: "the website is broken and I am sorry. y'all added to many good photos to the poster and I got cocky with the MEGABYTES",
    invitationId: "3S9FKWoiStvSA0Nc0PUN",
    createdOn: "2020-12-01T22:12:52.428Z",
  },
  {
    invitationId: "qQTX9WFnUFp4ZTNoXd4t",
    createdOn: "2020-12-01T22:48:26.423Z",
    text: "so many pixels, clogged the internet",
  },
  {
    text: "Done and done!",
    invitationId: "ZmlOcIn1dXFHGZs5ToG9",
    createdOn: "2020-12-02T01:49:16.140Z",
  },
  {
    createdOn: "2020-12-02T01:53:34.437Z",
    invitationId: "3S9FKWoiStvSA0Nc0PUN",
    text: 'Ok I fixed it. Everyone just press the "submit" button gently from now on.',
  },
  {
    invitationId: "dOGxLL423MSP7ZyJtHUx",
    text: "Hello friends!",
    createdOn: "2020-12-02T16:06:54.864Z",
  },
  {
    invitationId: "SLF1ar0kcGcZhkiQNERF",
    createdOn: "2020-12-03T14:27:56.708Z",
    text: "Bah!",
  },
  {
    text: "BAHHH",
    createdOn: "2020-12-03T14:39:52.902Z",
    invitationId: "3S9FKWoiStvSA0Nc0PUN",
  },
  {
    text: "Done!",
    invitationId: "HvBJNJxufagYMIiXxsYj",
    createdOn: "2020-12-03T17:09:11.741Z",
  },
  {
    text: "So... the poster site this year is kinda finicky. I tried a new thing and it's not working great. If you try to upload an image and it says \"success\" but doesn't eventually add your image to the poster, you can send me the image instead and I'll add it. :) ",
    invitationId: "3S9FKWoiStvSA0Nc0PUN",
    createdOn: "2020-12-03T18:31:07.672Z",
  },
  {
    text: "sorry!",
    createdOn: "2020-12-03T18:31:09.316Z",
    invitationId: "3S9FKWoiStvSA0Nc0PUN",
  },
  {
    text: "Where did my image go?  :-(",
    invitationId: "kBBCFSBIeqy0ETEWuZ9C",
    createdOn: "2020-12-05T04:53:16.215Z",
  },
  {
    createdOn: "2020-12-05T15:19:00.885Z",
    invitationId: "tnI3DXVe2XqA7VTQhmsY",
    text: "Amazing!",
  },
  {
    createdOn: "2020-12-05T15:19:15.806Z",
    text: "Thanks! Sorry Mom I don't what you're complaining about.",
    invitationId: "3S9FKWoiStvSA0Nc0PUN",
  },
  {
    createdOn: "2020-12-05T15:19:35.992Z",
    text: "Sounds like Frank needs to fix Mom & Dad's image! :~\\",
    invitationId: "tnI3DXVe2XqA7VTQhmsY",
  },
  {
    createdOn: "2020-12-05T15:19:45.830Z",
    text: "Sounds like you should butt out",
    invitationId: "3S9FKWoiStvSA0Nc0PUN",
  },
  {
    invitationId: "TSNNGaRZlpLSc9MjSx50",
    createdOn: "2020-12-15T01:24:15.728Z",
    text: "The Kabob image has been uploaded! Are we announcing things? I don't know if we're announcing things or not. I just announced it.",
  },
  {
    createdOn: "2020-12-15T02:04:56.367Z",
    text: "You can announce it! It's appreciated.",
    invitationId: "3S9FKWoiStvSA0Nc0PUN",
  },
  {
    invitationId: "3S9FKWoiStvSA0Nc0PUN",
    text: "I think it's kind of quiet in this VIP CHATROOM because all of these people are Professional Frank Poster submitters this year.",
    createdOn: "2020-12-15T02:05:15.887Z",
  },
  {
    invitationId: "dohFBC7ETCvtGbMfmAyU",
    text: "Meow",
    createdOn: "2020-12-15T04:20:22.177Z",
  },
  {
    text: "LOL @ slot the cottonelle",
    createdOn: "2020-12-21T15:17:57.320Z",
    invitationId: "RSXy3yUCAYAtofIAJqYz",
  },
  {
    text: "pizza/curbside pickup was the real MVP this year. :)",
    invitationId: "H4B2VRit6OQThALwFXUU",
    createdOn: "2020-12-21T21:32:26.631Z",
  },
  {
    invitationId: "3S9FKWoiStvSA0Nc0PUN",
    text: "oh dang the poster done got filled",
    createdOn: "2020-12-26T04:20:42.884Z",
  },
  {
    text: "neat!",
    createdOn: "2020-12-26T04:20:45.827Z",
    invitationId: "3S9FKWoiStvSA0Nc0PUN",
  },
  {
    createdOn: "2020-12-31T21:39:33.779Z",
    invitationId: "dohFBC7ETCvtGbMfmAyU",
    text: "Well, Friends... only a few hours left of 2020. The poster was kind of anticlamactic this year. :P",
  },
  {
    text: 'Last year I had to prod some folks to get their contributions in on time. But the poster was "done" a week in advance this year. Have a happy new year and a great 2021!',
    createdOn: "2020-12-31T21:40:16.769Z",
    invitationId: "dohFBC7ETCvtGbMfmAyU",
  },
];
